<script>
import AppIcon from "@/components/common/AppIcon.vue";
import moment from 'moment';

export default {
    name: 'LeaderBoardItems',
    components: { AppIcon },
    props: {
        data: {
            type: Object,
            default: () => ({
                leader_board: [],
                my_rank: null,
            }),
        },
    },
    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
    },
    methods: {
        moment,
        getLevelUrl(rank) {
            return `/themes/ito/images/lb-level-${rank}.svg`
        },
    }
}
</script>
<template>
    <div class="leader-board">
        <div class="leader-board-content">
            <div class="leader-board-header">
                <h3>{{ $t('leader_board') }}</h3>
                <AppIcon :src="$store.state.user_info.contest_info.gem_icon_url" :size="34" />
            </div>
            <div class="leader-board-body">
                <div class="nano" v-if="(data && data.leader_board && data.leader_board.length) > 0">
                    <div class="nano-content flex-column gap-2">
                        <div class="leader-board-item" v-for="(user, index) in data.leader_board" :key="index">
                            <div class="d-flex gap-3 overflow-hidden">
                                <div class="numb">
                                    <img :src="getLevelUrl(user.rank)" :alt="user.rank" v-if="user.rank <= 3" />
                                    <span v-else>{{ user.rank }}</span>
                                </div>
                                <div class="avatar">
                                    <div class="w-100 h-100 d-flex justify-content-center rounded-circle overflow-hidden" style="align-items: unset;">
                                        <img class="img-fluid" :src="user.student_avatar || '/themes/ito/images/avatar-default.svg'" alt="" />
                                    </div>
                                    <span class="emotion" v-if="user.student_emoji">
                                        <img class="img-fluid" :src="user.student_emoji" alt="">
                                    </span>
                                </div>
                                <div class="info">
                                    <p> {{ user.full_name || user.username }}</p>
                                    <small>{{ user.username }}</small>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="value" style="margin-left: auto;">
                                    {{ user.gem || user.username }}
                                    <AppIcon :src="$store.state.gem_icon_url" :size="20" />
                                </div>
                                <small v-if="user.updated_at">{{ `${$t('last_updated_at')} ${moment(user.updated_at).format('DD/MM/YYYY - HH:mm')}` }}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="leaderboard-empty-txt" v-else>
                    {{ $t('no_leader_board') }}
                </div>
            </div>
        </div>
        <div class="leader-board-footer" v-if="(data && data.leader_board && data.leader_board.length) > 0">
            <div class="leader-board-item" v-if="data.my_rank && data.my_rank.rank != 0">
                <div class="d-flex gap-3 align-items-center">
                    <div :class="{ numb: data.my_rank.rank > 3 }">
                        <img :src="getLevelUrl(data.my_rank.rank)" :alt="data.my_rank.rank" v-if="data.my_rank.rank <= 3" />
                        <span v-else>{{ data.my_rank.rank }}</span>
                    </div>
                    <div class="avatar">
                        <div class="w-100 h-100 d-flex justify-content-center rounded-circle overflow-hidden" style="align-items: unset;">
                            <img class="img-fluid" :src="data.my_rank.student_avatar || '/themes/ito/images/avatar-default.svg'" alt="" />
                        </div>
                        <span class="emotion" v-if="data.my_rank.student_emoji">
                            <img class="img-fluid" :src="data.my_rank.student_emoji" alt="">
                        </span>
                    </div>
                    <div class="info fw-bold">
                        {{ data.my_rank.full_name || data.my_rank.username }}
                    </div>
                </div>
                <div class="d-flex gap-3 align-items-center">
                    <div class="value">
                        {{ data.my_rank.gem | toCommas }}
                        <AppIcon :src="$store.state.gem_icon_url" :size="15" />
                    </div>
                </div>
            </div>
            <div class="leader-board-item no-rank" v-else>
                <p><b>{{ $t('you_not_rated') }}</b></p>
                {{ $t('leader_board_not_rated_gem_desc') }}
            </div>
        </div>
    </div>
</template>
<style scoped>
.leader-board {
    display: flex;
    gap: 20px;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
    background: #F5F5F5;
    border-radius: 8px;
    overflow: hidden;
}

.leader-board .leader-board-content {
    display: flex;
    flex-direction: column;
    height: 100%;
}


.leader-board .leader-board-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    line-height: 27px;
}

.leader-board .leader-board-header {
    background: #7F85E0;
}

.leader-board .leader-board-header h3 {
    margin: 0;
    font-weight: 700;
    font-size: 20px;
    color: #FFFFFF;

}

.leader-board .leader-board-body {
    height: 100%;
    padding: 8px 10px;
}

.leaderboard-empty-txt {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: #828282;
    padding-top: 30px;
    text-align: center;
}

.leader-board-item {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 8px 17px;
    height: 60px;
}

.leader-board-item .numb {
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.leader-board-footer .leader-board-item .numb {
    flex: 0 0 auto;
    width: unset;
    padding: 0 9px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: inset 0px 2px 0px rgba(255, 255, 255, 0.2);
    border-radius: 30px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    color: #6A6C7E;
    text-align: center;
}

.leader-board-item .numb span {
    width: 20px;
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    color: #000000;
}

.leader-board-item .avatar {
    flex: 0 0 auto;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.leader-board-footer .leader-board-item .avatar {
    width: 43px;
    height: 43px;
}

.leader-board-item .avatar .emotion {
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 18px;
    height: 18px;
    border: 3px solid #FFFFFF;
    border-radius: 90em;
}

.leader-board-item .info {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-style: normal;
    letter-spacing: 0.02em;
    padding: 0 13px;
    text-align: initial;
    color: #000000;
}

.leader-board-item .info p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #000000;
    margin: 0;
}

.leader-board-footer .leader-board-item .info {
    font-size: 16px;
}

.leader-board-item .info small,
.leader-board-item .value~small {
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: #000000;
    display: block;
    margin-top: 2px;
}

.leader-board-item .value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 0.02em;
    color: #6A6C7E;
}

.leader-board-footer .leader-board-item .value {
    font-size: 14px;
}

.leader-board .leader-board-footer {
    background: #E1E1E1;
    border-radius: 0;
    padding: 8px 10px;
}

.leader-board .leader-board-footer .leader-board-item.no-rank {
    gap: 0;
    flex-direction: column;
}
</style>